export default __webpack_public_path__ + "static/media/breakfast6.69132d5e.png";